import React, { useContext, useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { ThemeContext } from '../../context/ThemeContext';
import { NetworkContext } from '../../context/NetworkContext';
import { DefaultTokenContext } from '../../context/DefaultTokenContext';

import { Check, ScanLine, ClipboardPaste, NotebookTabs, X } from 'lucide-react';
// import { isValidAddress } from '../../utils/utils';

import DatePicker from 'react-datepicker'; // react-datepicker 사용
import 'react-datepicker/dist/react-datepicker.css'; // DatePicker 스타일 추가

import CustomButton from '../Componentization/CustomButton';
import CustomText from '../../styles/CustomText';
import CourierText from '../../styles/CourierText';
import CustomSwitch from '../Componentization/Switch/CustomSwtich';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText } from '../../store';

import useSecureStorage from '../../hooks/useSecureStorage';
import useQssWalletAddress, { QssWalletAddress } from '../../hooks/useQssWalletAddress';

import i18next from 'i18next'
import WebApp from '@twa-dev/sdk'
import BigNumber from 'bignumber.js';

import PinCodeScreen from '../Authentication/PinCodeScreen';
import SubPageHeader from '../../nav/SubPageHeader';
import Spinner from '../Componentization/Modal/Spinner';
import { tgShowAlert } from '../../utils/telegramPopup';

const WithdrawScreen: React.FC = () => {
	const { theme } = useContext(ThemeContext)
	const { sendTransactionWithPrivateKey, estimateGas, getBalance, isValidAddress } = useContext(NetworkContext)
	const { searchToken } = useContext(DefaultTokenContext);

	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();

	const { getWalletAddress } = useSecureStorage()
	const { getQssWalletAddress } = useQssWalletAddress()

	const [withdrawAddress, setWithdrawAddress] = useState('')
	const [withdrawAmount, setWithdrawAmount] = useState('')
	const [walletAddress, setWalletAddress] = useState('')
	const [termsAccepted, setTermsAccepted] = useState(false)
	const [isProcessing, setIsProcessing] = useState(false)
	const [isKeyboardVisible, setKeyboardVisible] = useState(false)
	const [gasFee, setGasFee] = useState<string | undefined>('0.0')
	const [isAddressValid, setIsAddressValid] = useState(false)
	const [isAmountValid, setIsAmountValid] = useState(false)
	const [addressHelperMessage, setAddressHelperMessage] = useState('')
	const [amountHelperMessage, setAmountHelperMessage] = useState('')
	const [showPinCodeAuth, setShowPinCodeAuth] = useState(false)
	const [isQssWalletListEnabled, setIsQssWalletListEnabled] = useState(false)
	const [isQssWalletAddressModalVisible, setIsQssWalletAddressModalVisible] = useState(false)
	const location = useLocation();
	const [token, setToken] = useState(location.state === null ? null : location.state.token);

	useEffect(() => {
		if (location.state) {
			setToken(location.state.token);
		}
	}, [location.state]);

	const { retrieveEncryptedData, getBlockChain, getNetworkCurrency } = useSecureStorage()

	const [privateKey, setPrivateKey] = useState<string | null>('')
	const [qssWalletAddressList, setQssWalletAddressList] = useState<QssWalletAddress[]>([]);
	const [selNetworkName, setSelNetworkName] = useState('')
	const [mainCurrency, setMainCurrency] = useState('')

	let isStartWithdrawal = false // 출금 시작 상태

	// 버튼 연속 클릭 방지
	const isClickedRef = useRef(false);
	
	useEffect(()=>{
		dispatch(checkHeaderText({ "link": "WithdrawScreen", "title": (token.symbol?.toUpperCase() || '')+'  '+t('stack_header_message_03') }))

		// QSS 지갑주소 리스트 초기화
		const initQssWalletAddress = async () => {
			// QSS 지갑주소 리스트
			const network = await getBlockChain()
            const qssWalletList = await getQssWalletAddress(network)
            // console.log(`QssSettingAddressScreen qss 저장된 지갑주소 리스트`, qssWalletList)

            if(false === qssWalletList.result) {
				// QSS에 저장된 지갑주소 데이터가 없음
				console.log(`QSS에 저장된 지갑주소 정보 없음`)
			} else {
				// QSS에 저장된 지갑주소 데이터가 있음
                // console.log(`QSS에 저장된 지갑주소 정보 있음 Value : `, qssWalletList.value)
				if(null != qssWalletList.value) {
					const value:QssWalletAddress[] = qssWalletList.value
					setQssWalletAddressList(value)
				}
			}

			// 현제 지갑에 선택된 네트워크
			const selNetwork = await getBlockChain()
			if(null != selNetwork || '' !== selNetwork) {
				setSelNetworkName(selNetwork)
				const currency = await getNetworkCurrency()
				setMainCurrency(currency)
			}
			else {
				console.log(`지갑에 설정된 네트워크 정보 없음`)
				tgShowAlert(i18next.t('template_wallet_screen_message_23'))
			}
		}
		const checkCoinBalance = async () => {
			setTimeout(async () => {
				const balance = await getBalance(walletAddress, true, 'cache')
				console.log(`checkCoinBalance balance : ${balance}`)
				if(0 === balance) {
					alert(i18next.t('withdraw_screen_message_32'))
				}
			}, 300);
		}

		initQssWalletAddress()
		checkCoinBalance()
	},[])

	useEffect(() => {
		const fetchAddress = async () => {
			const address: any = await getWalletAddress()
			if (address) {
				console.log(`estimatedGasFee start`)

				const estimatedGasFee = await estimateGas(address)
				console.log(`estimatedGasFee : ${estimatedGasFee}`)
				setGasFee(estimatedGasFee)	

				setWalletAddress(address)
			}
		}

		fetchAddress()

	// }, [estimateGas, getWalletAddress])
}, [getWalletAddress])

	useEffect(() => {
		validateAddress(withdrawAddress)
	}, [withdrawAddress])

	useEffect(() => {
		validateAmount(withdrawAmount)
	}, [withdrawAmount])

	useEffect(() => {
		const fetchAccountDetails = async () => {
			try {
				const walletAddress = await getWalletAddress()
				if (walletAddress) {
					
					setWalletAddress(walletAddress)

					// await getBalance(walletAddress)
					await Promise.all([getBalance(walletAddress)])
					// await Promise.all([getBalance(walletAddress, true, 'cache')]).then(([balance]) => {
					// 	console.log(`balance : ${balance}`)
					// 	// 네이티브 코인 수량이 0인 경우 알림창 표시
					// 	if(0 === balance) {	
					// 		alert(i18next.t('withdraw_screen_message_32'))
					// 	}
					// })
					
					console.log(`fetchAccountDetails complete`)
				}
			} catch (error) {
				console.error('Error fetching account details:', error)
			}

		}

		fetchAccountDetails()
	}, [token.symbol])

	// const handlePasteAddress = async () => {
	// 	const clipboardContent = await Clipboard.getString()
	// 	setWithdrawAddress(clipboardContent)
	// 	Toast.show({
	// 		type: 'success',
	// 		text1: i18next.t('template_withdraw_screen_message_15'),
	// 		position: 'bottom',
	// 		visibilityTime: 500
	// 	})
	// }

	/**
	 * 지갑주소 형식 확인
	 * @param address 
	 */
	const validateAddress = async (address: string) => {
		let isValid = true
		let message = ''

		if (address.length === 0) {
			isValid = false
			message = i18next.t('template_withdraw_screen_message_16')
		}

		if(false === await isValidAddress(address)) {
			isValid = false
			message = i18next.t('template_withdraw_screen_message_17')
		}

		// 내 지갑 주소와 동일한지 확인
		if(walletAddress === address) {
			isValid = false
			message = i18next.t('template_withdraw_screen_message_37')
		}

		setIsAddressValid(isValid)
		setAddressHelperMessage(message)
	}

	const validateAmount = async (amount: string) => {
		let isValid = true
		let message = ''

		const tokenBalance = Number(token.balance)
		const gasPrice = Number(gasFee)

		const availableBalance = tokenBalance
		const fee = gasPrice ? gasPrice : 0
		const withdrawAmount = parseFloat(amount)

		// 현재 선택된 코인/토큰 탭 정보 조회
		const tokenInfo = await searchToken(token.symbol)
		console.log(`WithdrawScreen validateAmount : `, tokenInfo)

		if(tokenInfo?.type === 'coin') {
			if (amount.length === 0) {
				isValid = false
				message = i18next.t('template_withdraw_screen_message_18')
			} else if (isNaN(withdrawAmount) || withdrawAmount <= 0) {
				isValid = false
				message = i18next.t('template_withdraw_screen_message_19')
			} else if (withdrawAmount > availableBalance - fee) {
				isValid = false
				message = i18next.t('template_withdraw_screen_message_20')
			}
		} else if(tokenInfo?.type === 'token') {
			if (amount.length === 0) {
				isValid = false
				message = i18next.t('template_withdraw_screen_message_18')
			} else if (isNaN(withdrawAmount) || withdrawAmount <= 0) {
				isValid = false
				message = i18next.t('template_withdraw_screen_message_19')
			} else if (withdrawAmount > availableBalance) {
				// 토큰은  수량 확인 시 fee 포함 안함
				isValid = false
				message = i18next.t('template_withdraw_screen_message_20')
			}
		} else {
			isValid = false
			message = i18next.t('template_withdraw_screen_message_20')
		}

		setIsAmountValid(isValid)
		setAmountHelperMessage(message)
	}

	const verificationBeforeWithdrawal = async () => {
		try {
			if (isClickedRef.current) {
				console.error('버튼 연속 클릭 차단')
				return;
			}
			isClickedRef.current = true;

			if(true === isStartWithdrawal) {
				alert(i18next.t('template_withdraw_screen_message_25'))
				return
			}
			
			// 출금 대상 지갑이 내 지갑주소와 동일한지 확인
			const myAddress = walletAddress
			if(withdrawAddress === myAddress) {
				await tgShowAlert(i18next.t('template_withdraw_screen_message_37'))
				return
			}

			// 메인 코인 보유량 조회
			const balance = await getBalance(walletAddress)
			const networkCurrency = await getNetworkCurrency()
	
			console.log(`verificationBeforeWithdrawal balance : ${balance}`)
			console.log(`verificationBeforeWithdrawal network currency : ${token.symbol}`)
			if(0 === balance || null == balance) {
				const text = i18next.t('template_withdraw_screen_message_32') + 
							' ' + networkCurrency + ' ' +
							i18next.t('template_withdraw_screen_message_33')
				await tgShowAlert(text)
				return
			}
			
			if(balance < Number(gasFee)) {
				const text = i18next.t('template_withdraw_screen_message_32') + 
							' ' + networkCurrency + ' ' +
							i18next.t('template_withdraw_screen_message_33')
				await tgShowAlert(text)
				return
			}
	
			setShowPinCodeAuth(true)
		} catch(error) {
			console.error('Error verificationBeforeWithdrawal', error);
		} finally {
			isClickedRef.current = false;
		}
	}

	const handleWithdraw = async (pin: string) => {
		if (!termsAccepted) {
			tgShowAlert(i18next.t('template_withdraw_screen_message_21'))
			return
		}

		if(true === isStartWithdrawal) {
			await tgShowAlert(i18next.t('template_withdraw_screen_message_25'))
			return
		}

		// 출금 시작 상태 변경
		isStartWithdrawal = true

		// 비밀키 데이터 복호화
		let privateKey: any
		let publicKey: any
		try {
			const network = await getBlockChain()
			const data = await retrieveEncryptedData(network, pin)
			privateKey = data.privateKey
			publicKey = data.publicKey
			if (!privateKey) {
				tgShowAlert(i18next.t('template_withdraw_screen_message_22'))
				return
			}
		} catch (error) {
			console.log('Error handleWithdraw', error)
			tgShowAlert(i18next.t('template_withdraw_screen_message_22'))
			return
		}

		setIsProcessing(true)

		try {
			const receipt = await sendTransactionWithPrivateKey(
				privateKey,
				withdrawAddress,
				withdrawAmount,
				token.symbol,
				token.address || '',
				publicKey || ''
			)
			
			console.log('토큰 전송 receipt : ', receipt)
			if(!receipt || receipt === '') {
				setIsProcessing(false)
				await tgShowAlert(i18next.t('template_withdraw_screen_message_24'))
				return
			}

			const options: Intl.DateTimeFormatOptions = {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				second: 'numeric',
				hour12: false
			};

			const padZero = (value: number) => {
				return value < 10 ? `0${value}` : value;
			}

			const date = new Date();

			// 각 시간 단위의 값을 얻어옵니다.
			const year = date.getFullYear();
			const month = padZero(date.getMonth() + 1);
			const day = padZero(date.getDate());
			const hours = padZero(date.getHours());
			const minutes = padZero(date.getMinutes());
			const seconds = padZero(date.getSeconds());

			const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

			const txId = receipt ? receipt: '';

			const withdrawData = {
				address: withdrawAddress,
				amount: `${withdrawAmount}`,
				fee: `${gasFee}`,
				date: formattedDate,
				txid: txId,
				symbol: token.symbol
			}

			setTimeout(() => {
				// @ts-ignore
				navigate('/WithdrawCompleteScreen', { state: { withdrawResult: withdrawData } })
			}, 1000)
		} catch (error: any) {
			setIsProcessing(false)
			if (error.code === 'INSUFFICIENT_FUNDS') {
				alert(i18next.t('template_withdraw_screen_message_20'))
			} else {
				alert(i18next.t('template_withdraw_screen_message_24'))
			}
		} finally {
			// 출금 시작 상태 변경
			isStartWithdrawal = false
		}
	}

	const handleMaxAmount = () => {
		const availableBalance = parseFloat(token.balance.toString())
		const fee = gasFee ? parseFloat(gasFee) : 0
		const margin = parseFloat('0.0001');
		const maxAmount = availableBalance - (fee + margin)

		setWithdrawAmount(maxAmount > 0 ? maxAmount.toFixed(6) : '0.0')
	}

	const isWithdrawButtonEnabled = isAddressValid && isAmountValid && termsAccepted

	const handlePinCodeintAuthSuccess = (pin: string) => {
		setShowPinCodeAuth(false)
		handleWithdraw(pin)
	}

	const handleQssSelWalletAddress = (index:number) => {
		
		try {
			// 선택한 QSS 지갑주소 닉네임 저장
			if (index >= 0 && index < qssWalletAddressList.length) {
				const selWallet = qssWalletAddressList[index]
				const title = selWallet.name +' '+ t('template_withdraw_screen_message_35')
				
				WebApp.showConfirm(title, (isSuccess: boolean) =>{
					if(true === isSuccess) {
						try {
							// 선택한 QSS 지갑주소 닉네임 저장
							// 지갑주소 inputbox에 설정
							setWithdrawAddress(selWallet.address)
						} catch (error) {
							console.warn(`Error Qss Sel Wallet address`, error);
						}
						setIsQssWalletAddressModalVisible(false)
					}
				});
			}
		} catch (error) {
			console.warn(`Error Qss Sel Wallet address`, error);
		}
	}

	const handleQRScan = async () => {
        WebApp.showScanQrPopup({text : 'QRCode를 스캔하시겠습니까?'}, TgWebAppQRCodeCameraCallBack)
    }

    const TgWebAppQRCodeCameraCallBack = (text: string): true | void  => {
        console.log(`TgWebAppQRCodeCameraCallBack : ${text}`)

        setWithdrawAddress(text)

        // true 리턴하면 QR코드 카메라 종료
        return true
    }

	// QSS 지갑주소 리스트 표시 토글
	const toggleQssWalletAddressSwitch = async () => {
		try {
			if(false === isQssWalletAddressModalVisible) {
				// QSS 지갑주소 리스트 접기 -> 펼침
				// setIsQssWalletListEnabled(true)
				setIsQssWalletAddressModalVisible(true)
			}
			else {
				// setIsQssWalletListEnabled(false)
				setIsQssWalletAddressModalVisible(false)
			}
		} catch (e) {
			console.error(e);
		}
	}

	const handleInputWithdrawAmount = (value: string) => {
		
		// 입력값이 비어있으면 그대로 반환
		// if (!value) {
		// 	return setWithdrawAmount(value);
		// }

		// 소수점으로 시작하는 경우
		if (value.startsWith('.')) {
			return;
		}

		// 숫자와 소수점만 허용하는 정규식
		const regex = /^\d*\.?\d*$/;
		if (!regex.test(value)) {
			return;
		}

		// 소수점이 있는 경우
		if (value.includes('.')) {
			const [integer, decimal] = value.split('.');
			// 소수점 이하 6자리까지만 허용
			if (decimal && decimal.length > 6) {
				return;
			}
		}
		
		setWithdrawAmount(value)
	}

	/**
	 * 전송내역 소수점 decimalPlaces 자리수로 표시하고, 정수부에 콤마를 찍는 함수
	 * - 아주 작은 수(1e-9 등)도 지수 표기가 아닌 일반 소수점 형태("0.000000001")로 표시
	 * - floor 로직(소수점 이하 절사)은 유지
	 * - NaN/null 이면 "0.000000000" 형태로 반환
	 */
	const formatNumberWithCommas = (
		input: BigNumber,
		decimalPlaces: number = 9
	): string => {
		// input이 null 또는 NaN이면 기본값 반환
		if (input === null || input.isNaN()) {
			return "0." + "0".repeat(decimalPlaces);
		}

		// 부호 결정 (BigNumber의 isNegative 사용)
		const absInput = input.abs();

		// 정수부 길이에 따라 소수점 자리수를 조정
		const integerPart = absInput.integerValue(BigNumber.ROUND_FLOOR);
		const integerStr = integerPart.toString();
		let effectiveDecimals = decimalPlaces;
		if (integerStr.length > 4) {
			effectiveDecimals = Math.max(0, decimalPlaces - (integerStr.length - 4));
		}

		const scale = new BigNumber(10).pow(effectiveDecimals);
		const floored = absInput.multipliedBy(scale).integerValue(BigNumber.ROUND_FLOOR).dividedBy(scale);
		const fixedStr = floored.toFixed(effectiveDecimals).replace(/\.?0+$/, ''); // 0만 있는 소수점 부분 제거

		let [intPart, decPart] = fixedStr.split(".");
		intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		
		return intPart + (decPart ? "." + decPart : "");
	};
	
	/**
	 * 전송 타입 선택 모달
	 * @returns 
	 */
	const renderQssWalletAddress = () => (
		<div style={styles.bottomModal}>
			<div style={styles.tradeModalContent}>
				<div style={styles.modalHeader}>
					<CustomText weight='medium' style={styles.modalTitle}>
						{i18next.t('template_wallet_screen_message_15')}
					</CustomText>
					<button onClick={() => setIsQssWalletAddressModalVisible(false)} style={{ background: 'none', border: 'none' }}>
						<X name='close' size={20} color={theme.text_01} />
					</button>
				</div>
				<div style={styles.modalListContainer}>
					{true === qssWalletAddressList.some((item) => item.network.toLowerCase() === selNetworkName.toLowerCase()) ? (
						qssWalletAddressList.map(
							(item, index) =>
								item.network.toLowerCase() === selNetworkName.toLowerCase() && (
									<div
										key={index}
										style={{ ...styles.transactionItem, backgroundColor: theme.fill_normal }}
										onClick={() => handleQssSelWalletAddress(index)}
									>
										<CustomText style={{ ...styles.itemTextNetwork, color: theme.text_01 }}>
											{item.network}
										</CustomText>
										<CustomText style={{ ...styles.itemText, color: theme.text_01 }}>
											{item.name}
										</CustomText>
										<ClipboardPaste color={theme.text_01} />
									</div>
								)
						)
					) : (
						<div key={0} style={{ ...styles.transactionItem, backgroundColor: theme.fill_normal }}>
							<CustomText style={{ ...styles.itemText, color: theme.text_01 }}>{t('qss_setting_wallet_screen_message_02')}</CustomText>
						</div>
					)}
				</div>
			</div>
		</div>
	)

	const styles = {
		container: {
			backgroundColor: theme.background_03,
			padding: "60px 0px 0",
		} as React.CSSProperties,
		contentContainer: {
			flexGrow: 1,
			padding: "0 20px",
			paddingTop: 30,
			paddingBottom: 10,
			borderTop: `1px solid ${theme.border_04}`,
			borderLeft: `1px solid ${theme.border_04}`,
			borderRight: `1px solid ${theme.border_04}`,
			borderBottom: `1px solid ${theme.border_04}`,
			borderTopLeftRadius: 10,
			borderTopRightRadius: 10,
			borderBottomLeftRadius: 10,
			borderBottomRightRadius: 10,
			width: "95%",
			boxSizing: "border-box"
		} as React.CSSProperties,
		label: {
			width: "100%",
			color: theme.text_01,
			fontSize: 18
		} as React.CSSProperties,
		inputRow: {
			display: 'flex',
			alignItems: 'center',
			marginTop: 26
		} as React.CSSProperties,
		inputAddress: {
			width: "100%",
			borderTop: "none",
			borderRight: "none",
			borderLeft: "none",
			borderBottom: `1px solid ${theme.border_04}`,
			outline: "none",
			fontSize: 16,
			height: "40px",
			background: "inherit"
		} as React.CSSProperties,
		helperText: {
			color: 'red',
			fontSize: 12,
			marginTop: 0,
			marginLeft: 0,
			height: 1
		} as React.CSSProperties,
		iconRow: {
			display: 'flex',
			justifyContent: 'flex-start',
			marginBottom: 25,
			marginTop: 13
		} as React.CSSProperties,
		iconButton: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: "100%"
		} as React.CSSProperties,
		iconText: {
			marginLeft: 5,
			fontSize: 13
		} as React.CSSProperties,
		amountRow: {
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			marginTop: 10
		} as React.CSSProperties,
		inputAmount: {
			width: "100%",
			borderTop: "none",
			borderRight: "none",
			borderLeft: "none",
			borderBottom: `1px solid ${theme.border_04}`,
			outline: "none",
			fontSize: 16,
			height: "40px",
			background: "inherit"
		} as React.CSSProperties,
		currency: {
			position: 'absolute',
			right: 18,
			fontSize: 16,
			color: theme.text_01
		} as React.CSSProperties,
		maxAmountText: {
			fontSize: 14,
			color: theme.text_08,
			textDecorationLine: 'underline',
			textAlign: "right"
		} as React.CSSProperties,
		infoBox: {
			backgroundColor: theme.card_background_01,
			borderRadius: 10,
			padding: 10,
			margin: "10px 0"
		} as React.CSSProperties,
		infoContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			padding: "5px"
		} as React.CSSProperties,
		infoText: {
			fontSize: 14,
			color: theme.text_03
		} as React.CSSProperties,
		infoAmount: {
			fontSize: 14,
			color: theme.text_03,
			display: "flex",
			gap: "10px"
		} as React.CSSProperties,
		infoSymbol: {
			fontSize: 14,
			color: theme.text_03
		} as React.CSSProperties,
		footerContainer: {
			padding:"10px 24px 25px",
			width:"100%",
			boxSizing:"border-box"
		} as React.CSSProperties,
		checkboxContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start'
		} as React.CSSProperties,
		checkboxBase: {
			width: "17px",
			height: "17px",
			borderRadius: 5,
			border: `1px solid ${theme.border_05}`,
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			marginRight: 5
		} as React.CSSProperties,
		checkboxText: {
			fontSize: 16,
			color: theme.text_09,
			marginLeft: 5
		} as React.CSSProperties,
		footer: {
			marginTop: 15
		} as React.CSSProperties,
		withdrawButton: {
			width: "100%",
			backgroundColor: theme.button_02,
			padding: 15,
			borderRadius: 10,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			height: 50
		} as React.CSSProperties,
		withdrawButtonText: {
			color: 'white',
			fontSize: 16
		} as React.CSSProperties,
		modalBackground: {
			display: "flex",
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: theme.background_alternative,
			position: "absolute",
			top: 0,
			left: 0,
			width: "100%",
			height: "100%",
			zIndex: "1000"
		} as React.CSSProperties,
		activityIndicatorWrapper: {
			backgroundColor: theme.card_background_02,
			height: "100%",
			width: "100%",
			borderRadius: 10,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		} as React.CSSProperties,
		processingText: {
			marginTop: 10,
			fontSize: 16
		} as React.CSSProperties,
		boxIconScan: {
			width: 15,
			height: 15,
			marginLeft: 10
		} as React.CSSProperties,
		boxIconPaste: {
			width: 15,
			height: 15
		} as React.CSSProperties,
		walletAddressListContainer: {
			// padding: "5px",
			// height: "500px",
			maxHeight: "calc(70vh - 265px)", // QSS 지갑주소가 있을 경우
			height: "auto", // 
			marginBottom: "20px",
			overflow: "auto"
		} as React.CSSProperties,
		transactionItem: {
            display: "flex",
            alignItems: 'center',
            padding: "13px 15px",
            borderRadius: 10,
            marginBottom: 10,
            border: `1px solid ${theme.line_neutral}`,
			cursor: "pointer"
        } as React.CSSProperties,
        transactionDetails: {
            // flex: 1
        } as React.CSSProperties,
        transactionName: {
            fontSize: 15
        } as React.CSSProperties,
        transactionAmountContainer: {
            display: "flex",
            alignItems: 'center'
        } as React.CSSProperties,
		itemTextNetwork: {
			fontSize: 14,
			paddingRight: "10px",
			color: theme.text_15,
			textAlign: "center",
		} as React.CSSProperties,
		itemText: {
			fontSize: 16,
			paddingRight: "10px",
			color: theme.text_15,
			flex: 1
		} as React.CSSProperties,
		itemTextToggle: {
			fontSize: 18,
			paddingRight: "10px",
			color: theme.text_15,
			textAlign: "left",
			flex: 1
		} as React.CSSProperties,
		qssWalletListRow: {
			display: 'flex',
			justifyContent: 'flex-start',
			marginBottom: 20,
			marginTop: 13
		} as React.CSSProperties,

		bottomModal: {
			display: "flex",
			margin: 0,
			width: "100%",
			height: "100%",
			position: "fixed",
			top: "0px",
			left: "0px",
			background: theme.background_alternative
		} as React.CSSProperties,
		modalHeader: {
			display: "flex",
			justifyContent: 'space-between',
			width: '100%',
			alignItems: 'center',
			marginBottom: 20,
			padding: "0 10px",
			boxSizing: "border-box",
		} as React.CSSProperties,
		modalTitle: {
			fontSize: 16,
			color: theme.text_01
		} as React.CSSProperties,
		tradeModalContent: {
			width: "100%",
			position: "absolute",
			bottom: "0px",
			left: "0px",
			backgroundColor: theme.background_02,
			padding: 20,
			borderTopLeftRadius: 30,
			borderTopRightRadius: 30,
			boxSizing: "border-box",
			maxHeight: "70vh",
			display: "flex",
			flexDirection: "column"
		} as React.CSSProperties,
		modalListContainer: {
			overflowY: "auto",
			maxHeight: "calc(70vh - 80px)", // 모달 헤더 높이와 패딩을 고려한 값
			paddingRight: 5
		} as React.CSSProperties,
		modalOption: {
			padding: "20px 10px",
			width: '100%',
			display: "flex",
			justifyContent: 'space-between',
			alignItems: 'center',
			boxSizing: "border-box"
		} as React.CSSProperties,
		modalOptionText: {
			fontSize: 16,
			color: theme.text_01
		} as React.CSSProperties,
		statusModalContent: {
			width: "100%",
			position: "absolute",
			bottom: "60px",
			left: "0px",
			backgroundColor: 'white',
			padding: 20,
			borderTopLeftRadius: 30,
			borderTopRightRadius: 30,
			boxSizing: "border-box"
		} as React.CSSProperties,
		optionPressableContainer: {
			display: "flex",
			alignItems: 'center',
		} as React.CSSProperties,
		modal: {
			maxWidth: '600px',
			margin: '0 auto',
			padding: '20px',
			borderRadius: '10px',
		} as React.CSSProperties,
		closeButton: {
			background: 'none',
			border: 'none',
			cursor: 'pointer',
			fontSize: '24px',
			color: theme.text_01,
			display: "flex",

		} as React.CSSProperties,
	}
	
	return (
		<>
		<SubPageHeader />
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
			<div style={{ width: '100%', display: 'flex', flexDirection: "column", alignItems: "center" }}>
				<div style={{ padding: '10px 24px', marginBottom: '15px 0', width: "100%", boxSizing: "border-box" }}>
					<CustomText style={{ color: theme.text_10, fontSize: '14px' }}>
					</CustomText>
				</div>
				<div style={styles.contentContainer}>
					<div>
						<CustomText weight="medium" style={{ ...styles.label, color: theme.label_strong }}>
							{i18next.t('template_withdraw_screen_message_02')}
						</CustomText>
						<div style={styles.inputRow}>
							<input
								value={withdrawAddress}
								onChange={(e) => setWithdrawAddress(e.target.value)}
								placeholder={i18next.t('template_withdraw_screen_message_03')}
								style={{
									...styles.inputAddress,
									borderBottomColor: theme.border_10,
									color: theme.label_strong,
								}}
								aria-invalid={!isAddressValid}
							/>
						</div>
						<p style={styles.helperText}>
							{!isAddressValid && withdrawAddress.length > 0 && (
								addressHelperMessage
							)}
						</p>
						
						<div style={styles.iconRow}>
							<button style={styles.iconButton} onClick={handleQRScan}>
								<ScanLine color={theme.text_10} />
								<CustomText style={{ ...styles.iconText, color: theme.text_10 }}>
									{i18next.t('template_withdraw_screen_message_04')}
								</CustomText>
							</button>
							<button style={styles.iconButton} onClick={toggleQssWalletAddressSwitch}>
								<NotebookTabs color={theme.text_10} />
								<CustomText style={{ ...styles.iconText, color: theme.text_10 }}>
									{i18next.t('template_withdraw_screen_message_34')}
								</CustomText>
							</button>
							{/* <button style={styles.iconButton}
							onClick={handlePasteAddress}
							>
								<img
									src={'./img/icon_withdraw_paste.png'}
									alt="Paste Address"
									style={styles.boxIconPaste}
								/>
								<CustomText style={{ ...styles.iconText, color: theme.text_10 }}>
									{i18next.t('template_withdraw_screen_message_05')}
								</CustomText>
							</button> */}
						</div>
						
						{/* <div style={styles.amountRow}>
							<CustomText weight="medium" style={{ ...styles.label, color: theme.label_strong }}>
								{(token.symbol?.toUpperCase() || '')+' '}{i18next.t('template_withdraw_screen_message_06')}
							</CustomText>
						</div> */}
						<div style={styles.inputRow}>
							<input
								type="text"
								inputMode="numeric"
								pattern="[0-9]*([.][0-9]+)?"
								value={withdrawAmount}
								onChange={(e) => handleInputWithdrawAmount(e.target.value)}
								placeholder={i18next.t('template_withdraw_screen_message_08')}
								style={{
									...styles.inputAmount,
									borderBottomColor: theme.border_10,
									color: theme.label_strong,
									width: 'calc(100% - 45px)', // 입력 필드의 너비를 조정하여 토큰 이름이 들어갈 공간을 확보
									paddingRight: '45px',
									textAlign: 'left' // 입력 텍스트를 우측정렬로 변경
								}}
								aria-invalid={!isAmountValid}
								maxLength={20}
							/>
							<CustomText weight="medium" 
								style={{ ...styles.currency, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '60px' }}>
								{token.symbol?.toUpperCase() || ''}
							</CustomText>
						</div>
						<div style={{ height: '20px' }}>
						{!isAmountValid && withdrawAmount.length > 0 && (	
							<p style={styles.helperText}>{amountHelperMessage}</p>
						)}
						</div>
						<div style={styles.infoBox}>
							<div style={styles.infoContainer}>
								<CustomText style={styles.infoText}>
									{i18next.t('template_withdraw_screen_message_09')}
								</CustomText>
								<CourierText weight="bold" style={styles.infoAmount}>
									{formatNumberWithCommas(BigNumber(token.balance))}{' '}{token.symbol?.toUpperCase() || ''}	
									{/* {formatNumberWithCommas(Number(token.balance))}{' '}{token.symbol?.toUpperCase() || ''} */}
								</CourierText>
							</div>
							<div style={{...styles.infoContainer, paddingTop: '8px'}}>
								<CustomText style={styles.infoText}>
									{i18next.t('template_withdraw_screen_message_10')}
								</CustomText>
								<CourierText weight="bold" style={styles.infoAmount}>
									{formatNumberWithCommas(BigNumber(gasFee||0))}{' '}{mainCurrency.toUpperCase()}
								</CourierText>
							</div>
						</div>
					</div>

				</div>
				
				{isQssWalletAddressModalVisible && renderQssWalletAddress()}

			</div>
			{!isKeyboardVisible && (
				<div style={styles.footerContainer}>
					<div style={styles.checkboxContainer}>
						<div
							style={{
								...styles.checkboxBase,
								backgroundColor: termsAccepted ? theme.primary_normal : theme.check_background_01,
								borderColor: termsAccepted
									? theme.check_background_03
									: theme.check_background_02,
							}}
							onClick={() => setTermsAccepted(!termsAccepted)}
						>
							{termsAccepted &&
								<Check
									name="checkmark"
									size={18}
									color={termsAccepted ? theme.check_background_03 : theme.check_background_03}
								/>
							}
						</div>
						<CustomText style={{ ...styles.checkboxText, color: theme.label_strong }} onClick={() => setTermsAccepted(!termsAccepted)}>
							{i18next.t('template_withdraw_screen_message_11')}
						</CustomText>
					</div>
					<div style={styles.footer}>
						<CustomButton
							containerStyle={{ ...styles.withdrawButton, backgroundColor: theme.primary_normal }}
							textStyle={{ 
								...styles.withdrawButtonText,
								color: !isWithdrawButtonEnabled ? theme.button_06 : styles.withdrawButtonText.color
							}}
							onPress={() => { verificationBeforeWithdrawal() }}
							text={i18next.t('template_withdraw_screen_message_12')}
							disabled={!isWithdrawButtonEnabled}
							disabledStyle={{ backgroundColor: theme.button_03 }}
							withBackground={true}
							backgroundColor={theme.background_08}
						/>
					</div>
				</div>
			)}
			{isProcessing && (
				<Spinner />
			)}

			{/* {isProcessing && (
			<Modal transparent={true} visible={isProcessing}>
				<View style={styles.modalBackground}>
					<View style={styles.activityIndicatorWrapper}>
						<ActivityIndicator size={50} color={theme.primary_normal} />
						<CustomText style={styles.processingText}>{i18next.t('template_withdraw_screen_message_25')}</CustomText>
					</View>
				</View>
			</Modal>
			)} */}

			{showPinCodeAuth && (
				<div style={styles.modalBackground}>
					<PinCodeScreen onSuccess={handlePinCodeintAuthSuccess} unlock={false} />
				</div>
			)}
		</div >
		</>
	)
}

export default WithdrawScreen
